export default {"src":"/_next/static/media/converter.c0a850d3.svg","height":20,"width":12,"blurWidth":0,"blurHeight":0};